/**
 * @file 慧播星打点
 * @description ubc sdk用法 https://console.cloud.baidu-int.com/devops/icode/repos/baidu/jady/ubc-report-sdk/blob/master/README.md
 * @author
 */

import {UbcLogger} from '@baidu/ubc-report-sdk';

const ernieId = 17186; // 脚本工具点
function log(type, params = {}, action = 'click') {
    try {
        const {value, extParam = {}} = params;
        const {logger, commonParams} = logMap[type];

        logger.send({
            ...commonParams,
            type: action,
            value,
            ext: extParam
        });

        // console.log('log =====>', {
        //     ...commonParams,
        //     type: action,
        //     value,
        //     ext: extParam
        // });
    }
    catch (e) {
        // safe log
    }
}
const ernieLogger = new UbcLogger({
    from: 'script',
    page: 'huibo',
    ev_l_t: 'click',
    appname: 'hui_bo_xing',
    serverId: ernieId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});
const logMap = {
    ernie: {
        logger: ernieLogger,
        commonParams: {
            from: 'script',
            pos_id: '1662_1667_',
            // pos_id: '1662__',
            ev_l_t: 'click'
        }
    }};

export const ernieLog = (tab, params) => {
    const valMap = {
        expand: 'extend', // 扩展文案
        reduce: 'simplify', // 精简
        improve: 'polish', // 润色
        adjust_tone: 'modify', // 语气
        redo: 'edit', // 重写
        cancel: 'cancel', // 取消
        confirm: 'confirm', // 设为播报文案
        exit: 'exit', // 退出
        insert: 'insert'// 下方插入
    };
    log('ernie', {
        value: valMap[tab],
        extParam: params
    });
};